module.exports = __webpack_public_path__ + "img/footer-contact-facebook.785a7df4.svg";